<template>
  <form @submit.prevent="submit">
    <slot></slot>
  </form>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "AsyncForm",
  props: {
    action: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapActions(["postAsync"]),
    submit(e) {
      this.postAsync({ path: `${this.action}.json`, formData: new FormData(e.target) })
        .then(() => e.target.reset())
        .catch(() => {});
    },
  },
};
</script>
